// This import loads the firebase namespace along with all its type information.
import MediationProcessTemplate from './mediation-process-template-model'

export async function load_mediationProcessTemplates(): Promise<
  MediationProcessTemplate[]
> {
  throw 'Not implemented'
}

export async function delete_mediationProcessTemplate(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediationProcessTemplate(): Promise<MediationProcessTemplate> {
  throw 'Not implemented'
}
